import { tenant } from '@tenant';
import type { TenantAuthPageLogo } from '@tenant';
import LogoInverse from '@tenant/assets/logo-inverse.svg';
import LogoPrimary from '@tenant/assets/logo-primary.svg';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import { useAccessToken } from 'hooks/context/useAccessToken';
import { useRedirectTo } from 'hooks/useRedirectTo';

import './authBackground.css';

const AUTH_PAGE_LOGOS = {
  inverse: LogoInverse,
  primary: LogoPrimary
} satisfies Record<TenantAuthPageLogo, unknown>;

const AuthPageLogo = AUTH_PAGE_LOGOS[tenant.authPageLogo];

export const AuthenticationLayout = () => {
  const { scopes } = useAccessToken();
  const [isLoggedIn] = useLocalStorage('isLoggedIn', false);

  const { navigateWithRedirectTo } = useRedirectTo();

  useEffect(() => {
    // we cannot only rely on the scopes from the tokens, we also have to check if the user isLoggedIn - this is because when the user logs out, the accessToken is still in memory but the localStorage flag is clean. We should consider centralizing this so that we only rely on the presence of the token
    if (scopes.includes('dashboard') && isLoggedIn) {
      navigateWithRedirectTo('/');
    }
  }, [isLoggedIn, navigateWithRedirectTo, scopes]);

  return (
    <main className="auth-background h-screen overflow-y-auto">
      <Outlet />
      <AuthPageLogo
        className="absolute right-12 top-10 hidden h-auto w-24 md:block"
        role="img"
        title={`${tenant.name.company} logo`}
      />
    </main>
  );
};
